module.exports = __webpack_public_path__ + "static/media/farming4.829c9439.png";